<template>
  <div class="container">
    <div class="manage-box">
      <img
        v-lazy="require('@/assets/manage-bg.png')"
        class="img"
        alt="丰派收银"
      />
      <div class="manage-text">
        <div class="text-box">
          <div class="div-text">让企业经营管理更高效 加速行业数字化升级</div>
          <div class="div-text2">——东莞市丰派软件科技有限公司</div>
        </div>
      </div>
    </div>
    <div class="company-box">
      <div class="company-img-box">
        <div class="company">
          <img :src="companybg1" class="img-bg" alt="" />
          <div
            class="img-text-box"
            @mouseenter="mouseenter1"
            @mouseleave="mouseleave1"
          >
            <div class="text-box">
              <div class="t1">公司介绍</div>
              <div class="t2">
                东莞市丰派软件科技有限公司是国内一家从事SaaS服务的企业，专注于为企业提供全渠道零售批发一站式数字化解决方案，助力企业在零售批发领域实现数字化转型。拥有多项核心自主知识产权。
              </div>
            </div>
            <div class="img-box">
              <img
                v-lazy="require('@/assets/introduceContent1.png')"
                class="img"
                alt=""
              />
            </div>
          </div>
        </div>
        <div class="company">
          <img :src="companybg2" class="img-bg" alt="" />
          <div
            class="img-text-box"
            @mouseenter="mouseenter2"
            @mouseleave="mouseleave2"
          >
            <div class="text-box">
              <div class="t1">公司文化</div>
              <div class="t2">公司价值观：平等、创新、高效、极致</div>
              <div class="t2">公司愿景：成为商家服务领域最值得信赖的伙伴</div>
              <div class="t2">企业文化：拼搏、个性、阳光</div>
            </div>
            <div class="img-box">
              <img
                v-lazy="require('@/assets/introduceContent2.png')"
                class="img"
                alt=""
              />
            </div>
          </div>
        </div>
        <div class="company">
          <img :src="companybg3" class="img-bg" alt="" />
          <div
            class="img-text-box"
            @mouseenter="mouseenter3"
            @mouseleave="mouseleave3"
          >
            <div class="text-box">
              <div class="t1">业务体系</div>
              <div class="t2">
                产品体系丰富，覆盖收银软件、订货商城、零售端小程序智能AI、大数据BI等业务产品。涉及零售、餐饮、服装、母婴等50多个细分行业，十数年的行业互联网运营经营。服务于上千家企业级用户和数十万终端用户。
              </div>
            </div>
            <div class="img-box">
              <img
                v-lazy="require('@/assets/introduceContent3.png')"
                class="img"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="developing-box">
      <div class="developing-text">
        <div class="div1">公司里程碑</div>
        <div class="div2">
          每一步都是一个脚印--
          <span
            @click="routerMenu('/web/webtimeLine')"
            style="color: #336fff; cursor: pointer"
            >所有事记</span
          >
        </div>
      </div>
      <div class="Timeline-box">
        <div class="left" @click="setLeft">
          <img src="@/assets/left.png" alt="" />
        </div>
        <div class="Timeline">
          <div
            class="Timeline-text"
            v-for="(item, index) in dataList"
            :key="item.id"
            @mouseenter="setTimeIndex(index)"
          >
            <div class="yuan" :class="index == timeIndex ? 'active' : ''"></div>
            <div class="text">{{ item.data }}</div>
          </div>
        </div>
        <div class="right" @click="setRight">
          <img src="@/assets/right.png" alt="" />
        </div>
      </div>
      <div class="Timeline-t-box">
        <div
          class="Timeline-t"
          v-for="(item1, index) in dataTextList"
          :key="item1.id"
          :class="index == timeIndex ? 'TimelineActive' : ''"
        >
          <div class="title">
            <span class="span1"></span>{{ item1.title }}
            <span class="span1"></span>
          </div>
          <div class="titie-t">{{ item1.text }}</div>
        </div>
      </div>
    </div>
    <div class="teambuilding-box">
      <div class="teambuilding-text">团建活动</div>
      <swiper class="swiper-img-box" :options="swiperOption4" ref="mySwiper4">
        <!-- <swiper-slide v-for="item in tjList" :key="item.id"> -->
        <div class="swiper-slide" v-for="item in tjList" :key="item.id">
          <img class="img" :src="item.img" alt="" />
        </div>
        <!-- </swiper-slide> -->
      </swiper>
    </div>
    <!-- <div class="introduceImg">
      <div class="introduceImg-container">
        <div class="introduceImg-container-img">
          <img
            class="introduceImg2"
            v-lazy="require('@/assets/introduceImg2.png')"
            alt="丰派收银"
          />
          <img
            class="introduceImg3"
            v-lazy="require('@/assets/introduceImg3.png')"
            alt="丰派收银"
          />
          <div class="introduceImg-shadow"></div>
        </div>
      </div>
    </div> -->
    <!-- <div class="introduceContent">
      <div class="introduceContent-container">
        <div
          class="introduceContent-item"
          v-for="item of introduceContentList"
          :key="item.id"
        >
          <div class="introduceContent-item-tit">{{ item.tit }}</div>
          <div
            :class="
              item.id == 2
                ? 'introduceContent-item-tip Wrap'
                : 'introduceContent-item-tip'
            "
          >
            {{ item.tip }}
          </div>
          <div class="introduceContent-item-img wow animate__animated animate__slideInUp">
            <img v-lazy="item.img" alt="item.tit" />
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
export default {
  name: "introduce",
  data() {
    return {
      timeIndex: 0,
      dataList: [
        {
          id: 1,
          data: 2017,
        },
        {
          id: 2,
          data: 2018,
        },
        {
          id: 3,
          data: 2019,
        },
        {
          id: 4,
          data: 2020,
        },
        {
          id: 5,
          data: 2021,
        },
      ],
      dataTextList: [
        {
          id: 1,
          title: "公司成立",
          text: "公司成立，公司发展客户数突破1000",
        },
        {
          id: 2,
          title: "市场调研",
          text: "发现市场需求，进行为期数月4w+用户终端的的市场调研，确定研发方向",
        },
        {
          id: 3,
          title: "订货商城发布 首获投资",
          text: "成立研发团队，订货商城正式上线，获得智百威第一轮投资",
        },
        {
          id: 4,
          title: "零售商城发布",
          text: "线上企业级客户数破千，终端用户突破20w+",
        },
        {
          id: 5,
          title: "收银软件发布",
          text: "获得市场强烈反响，支持Windows、Android、小程序多渠道运作",
        },
      ],
      tjList: [
        {
          id: 2,
          img: require("@/assets/tj2.png"),
        },
        {
          id: 1,
          img: require("@/assets/tj1.png"),
        },
        {
          id: 3,
          img: require("@/assets/tj3.png"),
        },
        {
          id: 4,
          img: require("@/assets/tj4.png"),
        },
        {
          id: 5,
          img: require("@/assets/tj5.png"),
        },
        {
          id: 6,
          img: require("@/assets/tj6.png"),
        },
      ],
      companybg1: require("@/assets/companybg1.png"),
      companybg2: require("@/assets/companybg1.png"),
      companybg3: require("@/assets/companybg1.png"),

      swiperOption4: {
        loop: true,
        slidesPerView: 3, // 加入这个属性
        // loopAdditionalSlides: 6,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
      },
    };
  },
  activated() {
    this.$nextTick(() => {
      this.$wow.init();
    });
  },

  methods: {
    routerMenu(result) {
      this.$router.push({ path: result });
    },
    setRight() {
      let i = this.dataList.length - 1;
      if (this.timeIndex == i) {
        this.timeIndex = 0;
      } else {
        this.timeIndex++;
      }
    },
    setLeft() {
      if (this.timeIndex == 0) {
        this.timeIndex = this.dataList.length - 1;
      } else {
        this.timeIndex--;
      }
    },
    setTimeIndex(value) {
      this.timeIndex = value;
    },
    mouseenter1() {
      this.companybg1 = require("@/assets/companybg2.png");
    },
    mouseleave1() {
      this.companybg1 = require("@/assets/companybg1.png");
    },
    mouseenter2() {
      this.companybg2 = require("@/assets/companybg2.png");
    },
    mouseleave2() {
      this.companybg2 = require("@/assets/companybg1.png");
    },
    mouseenter3() {
      this.companybg3 = require("@/assets/companybg2.png");
    },
    mouseleave3() {
      this.companybg3 = require("@/assets/companybg1.png");
    },
  },
};
</script>
<style lang="less" scoped>
.container {
  width: 100%;
  min-width: 1420px;
  background: #ffffff;
  position: relative;
  top: 64px;
}
.manage-box {
  width: 100%;
  position: relative;
  .img {
    width: 100%;
  }
  .manage-text {
    width: 1420px;
    left: 50%;
    transform: translateX(-50%);
    position: absolute;
    top: 28%;
    .text-box {
      width: 720px;
    }
    .div-text {
      font-size: 72px;
      color: #002864;
      line-height: 120px;
      font-weight: 500;
    }
    .div-text2 {
      text-align: right;
      font-size: 24px;
      color: #002864;
      line-height: 36px;
      margin-top: 16px;
    }
  }
}
.company-box {
  width: 100%;
  height: 590px;
  background: #f8faff;
  padding: 60px 0;
  .company-img-box {
    margin: 0 auto;
    width: 1280px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .company {
      width: 400px;
      height: 470px;
      position: relative;

      .img-bg {
        width: 100%;
        height: 100%;
      }
      .img-text-box {
        position: absolute;
        top: 0;
        left: 0;
        width: 400px;
        height: 470px;
        padding: 50px 30px;
        cursor: pointer;
        .text-box {
          height: 160px;
          margin-bottom: 40px;
          .t1 {
            font-size: 24px;
            line-height: 26px;
            color: #fff;
            margin-bottom: 20px;
          }
          .t2 {
            font-size: 14px;
            line-height: 26px;
            color: #fff;
          }
        }
        .img-box {
          width: 340px;
          height: 180px;
          .img {
            width: 100%;
            height: 100%;
          }
        }
        &:hover {
          .t1 {
            color: #002864;
          }
          .t2 {
            color: #002864;
          }
        }
      }
    }
  }
}
.developing-box {
  width: 100%;
  height: 540px;
  padding: 60px 0 0;
  background: linear-gradient(0deg, #ffffff, #ffffff), #f6f7fb;

  .developing-text {
    text-align: center;
    .div1 {
      font-size: 27px;
      line-height: 48px;
      color: #292929;
      margin-bottom: 12px;
    }
    .div2 {
      font-size: 16px;
      line-height: 22px;
      color: #3d485d;
    }
  }

  /*大事记start*/
  .Timeline-box {
    width: 1200px;
    margin: 60px auto 0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: linear-gradient(180deg, #f3f5f8 0%, #ffffff 100%);
      border: 2px solid #ffffff;
      box-sizing: border-box;
      box-shadow: 8px 8px 20px rgba(61, 72, 93, 0.2);
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .Timeline {
      width: 1000px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .Timeline-text {
        cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .yuan {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          border: 6px solid #ccc;
        }
        .active {
          border: 6px solid #ff9524;
        }
        .text {
          font-size: 20px;
          font-weight: 500;
        }
      }
    }
    .right {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: linear-gradient(180deg, #f3f5f8 0%, #ffffff 100%);
      border: 2px solid #ffffff;
      box-sizing: border-box;
      box-shadow: 8px 8px 20px rgba(61, 72, 93, 0.2);
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      .img {
        width: 6px;
        height: 10px;
      }
    }
  }
  .Timeline-t-box {
    width: 800px;
    height: 200px;
    margin: 40px auto 0;
    overflow: hidden;
    display: flex;
    position: relative;

    .Timeline-t {
      width: 100%;
      position: absolute;
      left: -800px;
      transform: translateX(-50%);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      &.TimelineActive {
        transition: all 1s;
        left: 50%;
      }
    }
    .title {
      text-align: center;
      display: flex;
      align-items: center;
      font-size: 36px;
      line-height: 48px;
      .span1 {
        display: inline-block;
        width: 100px;
        height: 1px;
        background: #29292920;
      }
    }
    .titie-t {
      font-size: 24xp;
      line-height: 32px;
      margin-top: 12px;
    }
  }
}
.teambuilding-box {
  width: 100%;
  height: 448px;
  background: #f8faff;
  padding: 60px 0;
  .teambuilding-text {
    text-align: center;
    font-size: 30px;
    line-height: 36px;
    color: #353535;
    margin-bottom: 30px;
  }
  .swiper-img-box {
    width: 1220px;
  }
  .swiper-slide {
    .img {
      width: 382px;
      margin: 0 12.335px;
    }
  }
}
// .introduceImg {
//   width: 100%;
//   height: 720px;
//   background: url("~@/assets/introduceImg1.png") no-repeat 0 0;
//   display: flex;
//   justify-content: center;
//   .introduceImg-container {
//     width: 1200px;
//     height: 720px;
//     display: flex;
//     justify-content: center;
//     .introduceImg-container-img {
//       position: relative;
//       margin-top: 234px;
//       width: 537px;
//       height: 440px;
//       .introduceImg2 {
//         width: 537px;
//         height: 440px;
//       }
//       .introduceImg3 {
//         width: 517px;
//         height: 344px;
//         position: absolute;
//         top: 10px;
//         left: 10px;
//       }
//       .introduceImg-shadow {
//         position: absolute;
//         left: 30px;
//         top: 400px;
//         width: 464px;
//         height: 48px;
//         background: radial-gradient(
//           50% 50% at 50% 50%,
//           #c4c4c4 0%,
//           rgba(196, 196, 196, 0) 100%
//         );
//       }
//     }
//   }
// }
// .introduceContent {
//   width: 100%;
//   height: 440px;
//   padding: 50px;
//   display: flex;
//   justify-content: center;
//   .introduceContent-container {
//     width: 1200px;
//     height: 340px;
//     display: flex;
//     align-items: center;
//     justify-content: space-around;
//     .introduceContent-item {
//       width: 350px;
//       height: 340px;
//       display: flex;
//       flex-direction: column;
//       //   justify-content: space-between;
//       //   margin-left:49px;
//       //   &:last-child{
//       //       margin-left:0;
//       //   }
//       .introduceContent-item-tit {
//         font-weight: 500;
//         font-size: 20px;
//         color: #353535;
//       }
//       .introduceContent-item-tip {
//         flex: 1;
//         margin-top: 20px;
//         font-weight: 350;
//         font-size: 14px;
//         color: #666666;
//       }
//       .Wrap {
//         width: 250px;
//       }
//       .introduceContent-item-img {
//         width: 350px;
//         height: 160px;
//         overflow: hidden;
//         img {
//           width: 350px;
//           height: 160px;
//         }
//       }
//     }
//   }
// }
.milestones {
  width: 100%;
  height: 634px;
  padding: 30px 30px 60px 30px;
  display: flex;
  justify-content: center;
  .milestones-container {
    width: 1200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    .milestones-tit {
      font-weight: 500;
      font-size: 30px;
      color: #353535;
    }
    .milestones-content {
      width: 1200px;
      height: 458px;
      display: flex;
      .milestones-content-one {
        width: 240px;
        height: 458px;
        position: relative;
        .milestones-content-one-Spindle {
          width: 240px;
          height: 10px;
          position: absolute;
          left: 0px;
          top: 224px;
          background: #3daab0;
        }
        .milestones-content-one-verticalBar {
          width: 3px;
          height: 224px;
          position: absolute;
          left: 237px;
          top: 0px;
          background: #3daab0;
          border-radius: 1px 0px 0px 0px;
        }
        .milestones-content-one-vector {
          width: 0;
          height: 0;
          border-top: 14px solid #3daab0;
          border-right: 22px solid transparent;
          position: absolute;
          left: 240px;
          top: 0px;
        }
        .milestones-content-one-tit {
          font-weight: 500;
          font-size: 18px;
          color: #353535;
          position: absolute;
          right: 4px;
          top: 0px;
        }
        .milestones-content-one-tip {
          width: 115px;
          height: 66px;
          font-weight: 350;
          font-size: 14px;
          color: #666666;
          position: absolute;
          right: 4px;
          top: 25px;
        }
        .milestones-content-one-year {
          position: absolute;
          width: 113px;
          height: 66px;
          left: 63px;
          top: 158px;
          font-weight: bold;
          font-size: 48px;
          color: #3daab0;
        }
      }
      .milestones-content-two {
        width: 240px;
        height: 458px;
        position: relative;
        .milestones-content-two-Spindle {
          width: 240px;
          height: 10px;
          position: absolute;
          left: 0px;
          top: 224px;
          background: #f54327;
        }
        .milestones-content-two-verticalBar {
          width: 3px;
          height: 224px;
          position: absolute;
          left: 237px;
          top: 234px;
          background: #f54327;
          border-radius: 1px 0px 0px 0px;
        }
        .milestones-content-two-vector {
          width: 0;
          height: 0;
          border-bottom: 14px solid #f54327;
          border-right: 22px solid transparent;
          position: absolute;
          left: 240px;
          bottom: 0px;
        }
        .milestones-content-two-tit {
          font-weight: 500;
          font-size: 18px;
          color: #353535;
          position: absolute;
          right: 4px;
          bottom: 88px;
        }
        .milestones-content-two-tip {
          width: 115px;
          // height: 66px;
          font-weight: 350;
          font-size: 14px;
          color: #666666;
          position: absolute;
          right: 4px;
          bottom: 5px;
        }
        .milestones-content-two-year {
          position: absolute;
          width: 113px;
          height: 66px;
          left: 63px;
          top: 234px;
          font-weight: bold;
          font-size: 48px;
          color: #f54327;
        }
      }
      .milestones-content-three {
        width: 240px;
        height: 458px;
        position: relative;
        .milestones-content-three-Spindle {
          width: 240px;
          height: 10px;
          position: absolute;
          left: 0px;
          top: 224px;
          background: #ff9524;
        }
        .milestones-content-three-verticalBar {
          width: 3px;
          height: 224px;
          position: absolute;
          left: 237px;
          top: 0px;
          background: #ff9524;
          border-radius: 1px 0px 0px 0px;
        }
        .milestones-content-three-vector {
          width: 0;
          height: 0;
          border-top: 14px solid #ff9524;
          border-right: 22px solid transparent;
          position: absolute;
          left: 240px;
          top: 0px;
        }
        .milestones-content-three-tit {
          font-weight: 500;
          font-size: 18px;
          color: #353535;
          position: absolute;
          right: 4px;
          top: 0px;
        }
        .milestones-content-three-tip {
          width: 115px;
          // height: 66px;
          font-weight: 350;
          font-size: 14px;
          color: #666666;
          position: absolute;
          right: 4px;
          top: 25px;
        }
        .milestones-content-three-year {
          position: absolute;
          width: 113px;
          height: 66px;
          left: 63px;
          top: 158px;
          font-weight: bold;
          font-size: 48px;
          color: #ff9524;
        }
      }
      .milestones-content-four {
        width: 240px;
        height: 458px;
        position: relative;
        .milestones-content-four-Spindle {
          width: 240px;
          height: 10px;
          position: absolute;
          left: 0px;
          top: 224px;
          background: #4fb3fb;
        }
        .milestones-content-four-verticalBar {
          width: 3px;
          height: 224px;
          position: absolute;
          left: 237px;
          top: 234px;
          background: #4fb3fb;
          border-radius: 1px 0px 0px 0px;
        }
        .milestones-content-four-vector {
          width: 0;
          height: 0;
          border-bottom: 14px solid #4fb3fb;
          border-right: 22px solid transparent;
          position: absolute;
          left: 240px;
          bottom: 0px;
        }
        .milestones-content-four-tit {
          font-weight: 500;
          font-size: 18px;
          color: #353535;
          position: absolute;
          right: 4px;
          bottom: 88px;
        }
        .milestones-content-four-tip {
          width: 115px;
          // height: 66px;
          font-weight: 350;
          font-size: 14px;
          color: #666666;
          position: absolute;
          right: 4px;
          bottom: 25px;
        }
        .milestones-content-four-year {
          position: absolute;
          width: 113px;
          height: 66px;
          left: 63px;
          top: 234px;
          font-weight: bold;
          font-size: 48px;
          color: #4fb3fb;
        }
      }
      .milestones-content-five {
        width: 240px;
        height: 458px;
        position: relative;
        .milestones-content-five-Spindle {
          width: 240px;
          height: 10px;
          position: absolute;
          left: 0px;
          top: 224px;
          background: #5a5358;
        }
        .milestones-content-five-verticalBar {
          width: 3px;
          height: 224px;
          position: absolute;
          left: 237px;
          top: 0px;
          background: #5a5358;
          border-radius: 1px 0px 0px 0px;
        }
        .milestones-content-five-vector {
          width: 0;
          height: 0;
          border-top: 14px solid #5a5358;
          border-right: 22px solid transparent;
          position: absolute;
          left: 240px;
          top: 0px;
        }
        .milestones-content-five-tit {
          font-weight: 500;
          font-size: 18px;
          color: #353535;
          position: absolute;
          right: 4px;
          top: 0px;
        }
        .milestones-content-five-tip {
          width: 127px;
          // height: 66px;
          font-weight: 350;
          font-size: 14px;
          color: #666666;
          position: absolute;
          right: 4px;
          top: 25px;
        }
        .milestones-content-five-year {
          position: absolute;
          width: 113px;
          height: 66px;
          left: 63px;
          top: 158px;
          font-weight: bold;
          font-size: 48px;
          color: #5a5358;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/introduce.vue